const TENANT_TO_LANG: Record<string, string> = {
  "gastearsivi": "tr",
  "historyworm": "en"
};

export default TENANT_TO_LANG;
